import { render, staticRenderFns } from "./GSBG.vue?vue&type=template&id=78b8798f&scoped=true&"
import script from "./GSBG.vue?vue&type=script&lang=js&"
export * from "./GSBG.vue?vue&type=script&lang=js&"
import style0 from "./GSBG.vue?vue&type=style&index=0&id=78b8798f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b8798f",
  null
  
)

export default component.exports